import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

export default function AnonymousAvatarMini({style=null}) {

    const [t] = useTranslation("global")

    const label = t("entity.anonymous")

    // https://picsum.photos/seed/${user.guid}/60/60
    //https://ui-avatars.com/api/?name=John+Doe

    return (
        <NavLink  className="btn btn-dark opacity-75" to=""style={style}>
            <img className="rounded-circle p-1 me-2 " width="48px" src={`https://ui-avatars.com/api/?name=${label}&background=dark-gray&color=FFF`}/>
            {label}
        </NavLink>
    )
}